<script lang="ts">
    import type { InformationDefinition } from 'header/types';

    interface Props {
        field: InformationDefinition;
    }

    let { field }: Props = $props();
</script>

<input
    class="input"
    type="text"
    disabled={field.changeable === false}
    value={field.value}
    readonly
/>

<style lang="scss" scoped>
    .input {
        width: 100%;
        color: gray;
    }
</style>
